import { Link } from '@/core'
import { AuthContent } from '@c/auth-app/auth-content'
import { useTranslation } from 'react-i18next'
import styles from './style.module.styl'

export const ResetPasswordSuccessPage = () => {
  const { t } = useTranslation()

  return (
    <AuthContent
      title={t('auth.resetPasswordSuccessPage.title')}
      extra={
        <Link name="login">
          {t('auth.resetPasswordSuccessPage.links.return_login')}
        </Link>
      }
    >
      <p className={styles.detail}>
        {t('auth.resetPasswordSuccessPage.message')}
      </p>
    </AuthContent>
  )
}
